import React from 'react';
import { colors, fonts, space } from '../tokens';

/**
 * KPIBox – Kennzahlen-Tile im KPI-Grid (z. B. Dachfläche, Leistung, Laufzeit).
 */
export const KPIBox = ({ icon: Icon, label, value, valueUnit, sub, accentColor = colors.navy }) => (
  <div className="kpi-tile" style={{ borderLeftColor: accentColor }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
      <Icon size={11} color={accentColor === colors.navy ? colors.orange : accentColor} strokeWidth={2} />
      <span style={{ fontFamily: fonts.body, fontSize: '8px', fontWeight: 700, color: colors.slateMid, textTransform: 'uppercase', letterSpacing: '0.08em' }}>{label}</span>
    </div>
    <p style={{ fontFamily: fonts.display, fontSize: '28px', fontWeight: 800, color: colors.navy, letterSpacing: '-0.03em', lineHeight: 1, margin: '0 0 2px' }}>
      {value} <span style={{ fontSize: '13px', fontWeight: 600 }}>{valueUnit}</span>
    </p>
    <p className="proposal-body" style={{ fontSize: '9px' }}>{sub}</p>
  </div>
);
